// Widget Scripts
import mainSlideshow from './js/widgets/mainSlideshow.js';
import autoEventFeed from './js/widgets/autoEventFeed.js';
import cardWidget from './js/widgets/cardWidget.js';
import seoBlock from './js/widgets/seoBlock.js';
import spinningNumbers from './js/widgets/spinningNumbers.js';
import scrollerSponsors from './js/widgets/scrollerSponsors.js';
import popup from './js/widgets/popup';
import partnerWidget from './js/widgets/partnerWidget';
import { themeController } from './js/themeController.js';

// Custom Theme Scripts
import './js/localjs.js';
import MicroModal from 'micromodal';

// Initialize Homepage Widgets
$(document).ready(function () {
  themeController(themeData);
  if (globalThis.location.pathname === '/') {
    mainSlideshow('mainSlideshow', mainSlideshowOpts);
    autoEventFeed();
    cardWidget();
    seoBlock();
    spinningNumbers();
    scrollerSponsors('scroller-sponsors-major', majorSponsorsOpts, 6);
    scrollerSponsors('scroller-sponsors-fairgrounds', scrollerSponsorsFairgroundsOpts, 4);
    partnerWidget();
    globalThis.addEventListener('load', function () {
      popup();
      MicroModal.init({
        awaitCloseAnimation: true,
      });
    });
  }
});
